import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs'
import { catchError, filter, map, take, tap, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { ConfigurationOption } from '../configuration-option'
import { configurationOptionActions } from '../configuration-option.actions'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ConfigurationOptionService } from '../configuration-option.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigOptionsKeys } from '../../../shared/constants'

export const DISABLED_CF_KEYS = {
  cardNumber: 'cardNumber'
}
@UntilDestroy()
@Component({
  selector: 'configuration-option-profile-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionProfileTabComponent implements OnInit {
  public optionValueProfile$: Subject<unknown> = new Subject<unknown>()
  public configOptionProfile$: Subject<ConfigurationOption> =
    new BehaviorSubject<ConfigurationOption>(null)
  public optionValueBankAccount$: Subject<unknown> = new Subject<unknown>()
  public configOptionBankAccount$: Subject<ConfigurationOption> =
    new BehaviorSubject<ConfigurationOption>(null)
  public optionValueNotification$: Observable<any>
  public isCollapsedProfile = false
  public isCollapsedBankAccount = true
  public isCollapsedNotifications = true
  public cfIsSelectedInMemberForm: boolean = true
  public formProfile: UntypedFormGroup
  public formBankAccount: UntypedFormGroup
  public formNotifications: UntypedFormGroup
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return ((acc[curr] = true), acc)
      else return acc
    },
    {}
  )
  public cfIsSelectedInBankAccountForm: boolean = true

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private actions$: Actions,
    private configOptionService: ConfigurationOptionService
  ) {}

  ngOnInit() {
    this.formProfile = this.fb.group({
      email: this.fb.group({
        title_en: ['Email', []],
        title_nl: ['Email', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Email', []],
        title_de: ['Email', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      firstName: this.fb.group({
        title_en: ['First name', []],
        title_nl: ['Voornaam', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['First name', []],
        title_de: ['First name', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      middleName: this.fb.group({
        title_en: ['Middle name', []],
        title_nl: ['Tussenvoegsel', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Middle name', []],
        title_de: ['Middle name', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      lastName: this.fb.group({
        title_en: ['Last name', []],
        title_nl: ['Achternaam', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Last name', []],
        title_de: ['Last name', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      birthDate: this.fb.group({
        title_en: ['Birthdate', []],
        title_nl: ['Geboortedatum', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Birthdate', []],
        title_de: ['Birthdate', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      shouldSync: this.fb.group({
        title_en: ['Should synchronize', []],
        title_nl: ['Synchronisatie', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Should synchronize', []],
        title_de: ['Should synchronize', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [false, []],
        isRequired: [false, []],
        isEditable: [false, []]
      }),
      language: this.fb.group({
        title_en: ['Language', []],
        title_nl: ['Taal', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Language', []],
        title_de: ['Language', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      phone: this.fb.group({
        title_en: ['Phone number', []],
        title_nl: ['Telefoonnummer', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Phone number', []],
        title_de: ['Phone number', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      mobile: this.fb.group({
        title_en: ['Mobile number', []],
        title_nl: ['Mobiel', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Mobile number', []],
        title_de: ['Mobile number', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      category: this.fb.group({
        title_en: ['Category', []],
        title_nl: ['Categorie', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Category', []],
        title_de: ['Category', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      street: this.fb.group({
        title_en: ['Street', []],
        title_nl: ['Straat', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Street', []],
        title_de: ['Street', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      houseNr: this.fb.group({
        title_en: ['House number', []],
        title_nl: ['Huisnummer', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['House number', []],
        title_de: ['House number', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      city: this.fb.group({
        title_en: ['City', []],
        title_nl: ['Stad', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['City', []],
        title_de: ['City', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      country: this.fb.group({
        title_en: ['Country', []],
        title_nl: ['Land', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Country', []],
        title_de: ['Country', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      zipcode: this.fb.group({
        title_en: ['Zipcode', []],
        title_nl: ['Postcode', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Zipcode', []],
        title_de: ['Zipcode', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      postbox: this.fb.group({
        title_en: ['Postbox', []],
        title_nl: ['Postbus', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Postbox', []],
        title_de: ['Postbox', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      id: this.fb.group({
        title_en: ['Person id', []],
        title_nl: ['Person id', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Person id', []],
        title_de: ['Person id', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [false, []],
        isEditable: [false, []]
      }),
      chamberOfCommerceId: this.fb.group({
        title_en: ['Chamber of Commerce', []],
        title_nl: ['Kamer van Koophandel', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Chambre de Commerce', []],
        title_de: ['Handelskammer', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [false, []],
        isRequired: [false, []],
        isEditable: [false, []]
      }),
      balance: this.fb.group({
        title_en: ['Balance', []],
        title_nl: ['Balance', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Balance', []],
        title_de: ['Balance', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [false, []],
        isEditable: [false, []]
      }),
      externalKey: this.fb.group({
        title_en: ['External Key', []],
        title_nl: ['External Key', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['External Key', []],
        title_de: ['External Key', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [false, []],
        isEditable: [false, []]
      }),
      municipality: this.fb.group({
        title_en: ['Municipality', []],
        title_nl: ['Municipality', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Municipality', []],
        title_de: ['Municipality', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      region: this.fb.group({
        title_en: ['Region', []],
        title_nl: ['Region', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Region', []],
        title_de: ['Region', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      gender: this.fb.group({
        title_en: ['Gender', []],
        title_nl: ['Gender', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Gender', []],
        title_de: ['Gender', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      memberNumber: this.fb.group({
        title_en: ['Member/student/employee number', []],
        title_nl: ['Member/student/employee number', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Member/student/employee number', []],
        title_de: ['Member/student/employee number', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      cardNumber: this.fb.group({
        title_en: ['Card number', []],
        title_nl: ['Kaartnummer', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Card number', []],
        title_de: ['Kartennummer', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      group: this.fb.group({
        title_en: ['Group', []],
        title_nl: ['Groep', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['groupe', []],
        title_de: ['Gruppe', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      status: this.fb.group({
        title_en: ['Status', []],
        title_nl: ['Status', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Status', []],
        title_de: ['Status', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      memo: this.fb.group({
        title_en: ['Memo', []],
        title_nl: ['Memo', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Memo', []],
        title_de: ['Memo', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [false, []],
        isEditable: [false, []]
      })
    })

    this.formBankAccount = this.fb.group({
      bankAccount: this.fb.group({
        title_en: ['Bank account', []],
        title_nl: ['Bank account', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Bank account', []],
        title_de: ['Bank account', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      }),
      bankAccountHolder: this.fb.group({
        title_en: ['Bank account holder', []],
        title_nl: ['Bank account holder', []],
        placeholder_nl: ['', []],
        placeholder_en: ['', []],
        title_fr: ['Bank account holder', []],
        title_de: ['Bank account holder', []],
        placeholder_fr: ['', []],
        placeholder_de: ['', []],
        isVisible: [true, []],
        isRequired: [true, []],
        isEditable: [true, []]
      })
    })

    this.formNotifications = this.fb.group({
      notifications_agreements_display_offers: [null, []],
      notifications_agreements_display_newsletters: [null, []]
    })

    this.optionValueNotification$ = combineLatest([
      this.store.select(
        configurationOptionSelectors.selectByKey,
        'notifications_agreements_display_offers'
      ),
      this.store.select(
        configurationOptionSelectors.selectByKey,
        'notifications_agreements_display_newsletters'
      )
    ]).pipe(
      tap(([configOptionOffers, configOptionNewsletters]) =>
        this.formNotifications.patchValue({
          notifications_agreements_display_offers: Boolean(
            Number(configOptionOffers?.value)
          ),
          notifications_agreements_display_newsletters: Boolean(
            Number(configOptionNewsletters?.value)
          )
        })
      )
    )
    this.configOptionProfile$
      ?.pipe(
        untilDestroyed(this),
        filter((x) => Boolean(x))
      )
      .subscribe((option) => {
        const parsedValue = JSON.parse(option.value ?? '[]').reduce(
          (formData, inputGroup) => ({
            ...formData,
            [inputGroup.inputName]: inputGroup
          })
        )
        this.optionValueProfile$.next(parsedValue)
        this.formProfile.patchValue(parsedValue)
      })

    this.configOptionBankAccount$
      ?.pipe(
        untilDestroyed(this),
        filter((x) => Boolean(x))
      )
      .subscribe((option) => {
        const parsedValue = JSON.parse(option.value ?? '[]').reduce(
          (formData, inputGroup) => ({
            ...formData,
            [inputGroup.inputName]: inputGroup
          }),
          {}
        )
        this.optionValueBankAccount$.next(parsedValue)
        this.formBankAccount.patchValue(parsedValue)
      })

    this.setFormMemberProfileValues()
    this.setFormBankAccountValues()
  }

  public onVisibleInputChange(formFieldName: string) {
    if (!this.formProfile.value[formFieldName]?.isVisible) {
      this.formProfile.controls[formFieldName]['controls'][
        'isRequired'
      ].patchValue(false)
      this.formProfile.controls[formFieldName]['controls'][
        'isEditable'
      ].patchValue(false)
    }
  }

  public onSubmitProfile(): void {
    this.configOptionProfile$.pipe(take(1)).subscribe((configOption) => {
      const configOptionValue = JSON.stringify(
        Object.keys(this.formProfile.value)
          .filter((key) =>
            this.cfIsSelectedInMemberForm ? DISABLED_CF_KEYS[key] !== key : true
          )
          .map((key) => {
            if (!this.formProfile.value[key]['isVisible']) {
              this.formProfile.value[key]['isRequired'] = false
              this.formProfile.value[key]['isEditable'] = false
            }
            return {
              ...this.formProfile.value[key],
              inputName: key
            }
          })
      )

      const memberProfileKey = this.cfIsSelectedInMemberForm
        ? ConfigOptionsKeys.MEMBER_PROFILE_FORM_CONFIG
        : ConfigOptionsKeys.AP_MEMBER_FORM_CONFIG

      if (!configOption || !configOption.id) {
        this.store.dispatch(
          configurationOptionActions.createOne({
            entity: {
              key: memberProfileKey,
              value: configOptionValue
            }
          })
        )
      } else {
        this.store.dispatch(
          configurationOptionActions.updateOneById({
            id: configOption.id,
            params: {
              value: configOptionValue
            }
          })
        )
      }
    })

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  public onSubmitBankAccount(): void {
    this.configOptionBankAccount$.pipe(take(1)).subscribe((configOption) => {
      const configOptionValue = JSON.stringify(
        Object.keys(this.formBankAccount.value).map((key) => ({
          ...this.formBankAccount.value[key],
          inputName: key
        }))
      )

      const bankAccountKey = this.cfIsSelectedInBankAccountForm
        ? ConfigOptionsKeys.BANKACCOUNT_DETAIL_CONFIG
        : ConfigOptionsKeys.AP_BANKACCOUNT_DETAIL_CONFIG

      if (!configOption || !configOption.id) {
        this.store.dispatch(
          configurationOptionActions.createOne({
            entity: {
              key: bankAccountKey,
              value: configOptionValue
            }
          })
        )
      } else {
        this.store.dispatch(
          configurationOptionActions.updateOneById({
            id: configOption.id,
            params: {
              value: configOptionValue
            }
          })
        )
      }
    })

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  public setFormMemberProfileValues() {
    this.cfIsSelectedInMemberForm = !this.cfIsSelectedInMemberForm
    const formConfigValue = this.cfIsSelectedInMemberForm
      ? ConfigOptionsKeys.MEMBER_PROFILE_FORM_CONFIG
      : ConfigOptionsKeys.AP_MEMBER_FORM_CONFIG
    this.store
      .select(configurationOptionSelectors.selectByKey, formConfigValue)
      .pipe(take(1))
      .subscribe((memberProfile) => {
        // If there is no AP Member Profile data get Member Profile and set it as AP data
        if (!memberProfile && !this.cfIsSelectedInMemberForm) {
          this.store
            .select(
              configurationOptionSelectors.selectByKey,
              ConfigOptionsKeys.MEMBER_PROFILE_FORM_CONFIG
            )
            .pipe(take(1))
            .subscribe((memberProfile) => {
              this.configOptionProfile$.next({
                ...memberProfile,
                id: null,
                key: ConfigOptionsKeys.AP_MEMBER_FORM_CONFIG
              })
            })
        } else {
          this.configOptionProfile$.next(memberProfile)
        }
      })
  }

  public setFormBankAccountValues() {
    this.cfIsSelectedInBankAccountForm = !this.cfIsSelectedInBankAccountForm
    const formConfigValue = this.cfIsSelectedInBankAccountForm
      ? ConfigOptionsKeys.BANKACCOUNT_DETAIL_CONFIG
      : ConfigOptionsKeys.AP_BANKACCOUNT_DETAIL_CONFIG
    this.store
      .select(configurationOptionSelectors.selectByKey, formConfigValue)
      .pipe(take(1))
      .subscribe((bankAccount) => {
        // If there is no AP Bank Account data get CF Bank Account and set it as AP data
        if (!bankAccount && !this.cfIsSelectedInBankAccountForm) {
          this.store
            .select(
              configurationOptionSelectors.selectByKey,
              ConfigOptionsKeys.BANKACCOUNT_DETAIL_CONFIG
            )
            .pipe(take(1))
            .subscribe((bankAccount) => {
              this.configOptionBankAccount$.next({
                ...bankAccount,
                id: null,
                key: ConfigOptionsKeys.AP_BANKACCOUNT_DETAIL_CONFIG
              })
            })
        } else {
          this.configOptionBankAccount$.next(bankAccount)
        }
      })
  }

  public onSubmitNotifications(): void {
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
    this.configOptionService.updateOrCreateMany(this.formNotifications.value)
  }
}
